export const CONTACT_CTAS_CONTEXT = Symbol("contact-ctas-context");

/* USAGE:
In the top level component you wish to use CTAs in, add the following:

import { CONTACT_CTAS_CONTEXT } from "./context";
import { setContext } from "svelte";

setContext(CONTACT_CTAS_CONTEXT, {
    activePopUpModalStore,
    activityFeedStore,
    callAnsweredStore,
    candidateStore,
    candidatePhoneStore,
    itemStore, (e.g. for todos modal item store)
});

Then in the child component you wish to use the CTAs in, add the following:
import { ContactCtasContainer } from "./ContactCtasContainer.svelte";

<ContactCtasContainer
  CallDropdownCta,
  SendWhatsappCta,
  SendSmsCta,
  LogActivityCta,
  AddToContactsCta,
  AddToCampaignCta,  (Omit any of these to not show them)
/>

You will also need a PopUpModal component to read activePopUpModalStore and
display the appropriate modal based on the CTA clicked.

Note: This approach means it's currently not possible to use the CTAs in multiple places on the same page.
*/
